import React from 'react'
import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {PageTitle} from 'src/_metronic/layout/core'
import MyTasksListing from './components/MyTasksListing'

const MyTasksPage: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route path='my-tasks-listing' element={<><PageTitle breadcrumbs={[{title: 'My Tasks Listing', path: '', isSeparator: false, isActive: true}]}>My Tasks Listing</PageTitle><MyTasksListing /></>} />
      </Route>
    </Routes>
  )
}

export default MyTasksPage
